export const categoryLink = (category) => {
  const slugs = (category?.subcategories || [])
    .map((sub) => sub?.slug)
    .filter(Boolean);

  if (!slugs.length) return "/shop";
  return `/shop?category=${slugs.join(",")}`;
};
